export interface IEmojiData {
   id: string;
   name: string;
   skin: number;
}

const emojiReactions: IEmojiData[] = [
   {
      id: '+1',
      name: 'Thumbs Up',
      skin: 0
   },
   {
      id: '-1',
      name: 'Thumbs Down',
      skin: 0
   },
   {
      id: 'open_mouth',
      name: 'Face with Open Mouth',
      skin: 0
   },
   {
      id: 'joy',
      name: 'Face with Tears of Joy',
      skin: 0
   },
   {
      id: 'heart',
      name: 'Red Heart',
      skin: 0
   },
   {
      id: 'tada',
      name: 'Party Popper',
      skin: 0
   }
];

export default emojiReactions;
